import React from 'react'
import classnames from 'classnames'
import { getWorkshopDaysOfWeek } from 'shared/utils/dates'
import './WorkshopDaysOfWeek.scss'
import { VisuallyHidden } from '@reach/visually-hidden'

const DAYS = [
  { text: 'Sunday', abbr: 'S' },
  { text: 'Monday', abbr: 'M' },
  { text: 'Tuesday', abbr: 'T' },
  { text: 'Wednesday', abbr: 'W' },
  { text: 'Thursday', abbr: 'Th' },
  { text: 'Friday', abbr: 'F' },
  { text: 'Saturday', abbr: 'S' },
]

export default function WorkshopDaysOfWeek({ startDate, days: totalDays }) {
  const days = getWorkshopDaysOfWeek(startDate, totalDays)
  return (
    <span className={classnames('workshop-days-of-week')} aria-hidden>
      {DAYS.map(({ abbr }, day) => {
        const on = day >= days.start && day <= days.end
        return (
          <span key={day} className={classnames('day', { on })}>
            {abbr}
          </span>
        )
      })}
      {/* <VisuallyHidden>{onLabel}</VisuallyHidden> */}
    </span>
  )
}
